// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"063699c3","703":"64d70ef9","787":"036cd6ef"}[chunkId] + ".chunk.js";
};